import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Stack } from "expo-router";
import { TailwindProvider } from "tailwind-rn";
import { PaperThemeProvider } from "ui";

import utilities from "../../tailwind.json";
import { APIProvider } from "../contexts/api-context";

const queryClient = new QueryClient();

export default function Layout() {
  return (
    <TailwindProvider utilities={utilities}>
      <PaperThemeProvider>
        <QueryClientProvider client={queryClient}>
          <APIProvider baseURL="https://examples.cuanto.app" userId={9688}>
            <Stack screenOptions={{ headerShown: false }} />
          </APIProvider>
        </QueryClientProvider>
      </PaperThemeProvider>
    </TailwindProvider>
  );
}
